import { useFlags } from 'launchdarkly-react-client-sdk';
import { useUser } from '../api/user/useUser';
import useProperties from '../api/properties/useProperties';
import featureConfig, { getSingleActiveProjectId } from '../config/featureConfig';
import { LDFlags } from '../config';
import { ROUTE } from '../routes';

export const useLandingRoute = (): string => {
  const { user } = useUser();
  const flags = useFlags() as LDFlags;
  const { data: property } = useProperties(user?.propertyIds?.[0]);

  if (featureConfig.displayProjectAsHome(user, flags)) {
    const id = getSingleActiveProjectId(user);
    if (id) return ROUTE.PROJECT_DETAIL.replace('$id', id);
  }

  return featureConfig.displayHomePage(user, undefined, property) ? ROUTE.HOME : ROUTE.ENERGY;
};
